import { Errors } from '../../shared/errors';
import { MhElement } from '../../shared/interfaces';

export const getInfo = async (requiredInfo: string[], optionalInfo: string[], elements: Record<string, MhElement>): Promise<any> => {
    const info: any = {};
    const errors: string[] = [];

    requiredInfo.forEach((infoName) => {
        const element = elements[infoName];

        if (element && (element.input instanceof HTMLInputElement || element.input instanceof HTMLSelectElement)) {
            info[infoName] = element.input.value;
            return;
        }

        errors.push(`Missing required information "${infoName}".`);
    });

    optionalInfo.forEach((infoName) => {
        const element = elements[infoName];

        if (element && (element.input instanceof HTMLInputElement || element.input instanceof HTMLSelectElement)) {
            info[infoName] = element.input.value;
        }
    });

    if (errors.length > 0) {
        throw new Errors(errors);
    }

    return info;
};
